import ApiService from "../../api.service";

export const GET_LIST_TAX_INVOICE = "tariffs"
export const IMPORT_TAX_INVOICE = "tariffs/import"
export const PREVIEW_IMPORT_TAX_INVOICE = "tariffs/preview-import"
export const EXPORT_TAX_INVOICE = "tariffs/export?all=true"
export const UPDATE_STATUS_TAX_INVOICE = "tariffs/update-status"
export const STUDENT_TAX_INVOICE = "student-tax-invoice"
export const CLASSROOM_TAX_INVOICE = "class-tax-invoice"
export const ISSUE_INVOICES = "tariffs/issue-invoices"

const state = {};

const getters = {};

const actions = {
    [GET_LIST_TAX_INVOICE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_LIST_TAX_INVOICE, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [PREVIEW_IMPORT_TAX_INVOICE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(PREVIEW_IMPORT_TAX_INVOICE, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [IMPORT_TAX_INVOICE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(IMPORT_TAX_INVOICE, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [UPDATE_STATUS_TAX_INVOICE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(UPDATE_STATUS_TAX_INVOICE, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [EXPORT_TAX_INVOICE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(EXPORT_TAX_INVOICE, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [STUDENT_TAX_INVOICE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(STUDENT_TAX_INVOICE, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [CLASSROOM_TAX_INVOICE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(CLASSROOM_TAX_INVOICE, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [ISSUE_INVOICES](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(ISSUE_INVOICES, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
};


const mutations = {};

export default {
    state,
    actions,
    mutations,
    getters
}